import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {UserSearchType} from 'ui-library/entity-input/EntityInputWithSearch';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';
import EditablePartyField from 'ui-library/inputs/EditablePartyField';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

import {ProcessDetailsQuery} from './__generated/ProcessDetailsQuery';

type ProcessWatcher = ExtractByTypename<
  ProcessDetailsQuery['process'],
  'ProcessNode'
>['watcherParties'][number];

interface ProcessWatchersFieldProps {
  isLoading?: boolean;
  watchers: Array<ProcessWatcher>;
  onChange: (watchers: Array<ProcessWatcher>) => Promise<void>;
  isDisabled: boolean;
}

export function ProcessWatchersField(props: ProcessWatchersFieldProps): JSX.Element {
  if (props.isLoading) {
    return <HorizontalThrobber />;
  }
  return (
    <EditablePartyField
      value={props.watchers}
      onChange={props.onChange}
      isDisabled={props.isDisabled}
      chipSize={TagsInputSize.SMALL}
      enableNewEntityInput={true}
      allowEmails={false}
      allowTeams={true}
      allowOrganizations={false}
      shouldAllowMultiple={true}
      userSearchType={UserSearchType.NotSuspended}
      isFullWidth={false}
      initialIsBeingEdited={false}
      allowEmptyValue={true}
      shouldUseCompactDisplay={true}
      useAvatars={true}
      maxAvatars={2}
    />
  );
}
